module.exports = __webpack_public_path__ + "static/img/aixy2.e16dda7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aixy2.png
// module id = +MI1
// module chunks = 0